export const isOptionsCustomPeriodRestricted = ({ isPro, range }) => !isPro && range === 'custom';

export const isOptionsHistoryViewRestricted = ({ isPro, view }) => !isPro && ['campaigns', 'rolls'].includes(view);

export const isOptionsAlertLimitReached = ({ isPro, activeCount, limit = 1 }) => !isPro && activeCount >= limit;